import { JsonParser } from '@1inch-community/core/storage';
export function setChainIdInStorage(storage, chainId) {
    storage.set('chainId', Number(chainId));
}
export function getChainIdsFromStorage(storage) {
    return storage.get('chainIds', JsonParser);
}
export function setActiveAddress(storage, address) {
    storage.set('activeAddress', address);
}
export function getActiveAddress(storage) {
    return storage.get('activeAddress', String);
}
export function setActiveWallet(storage, id) {
    storage.set('activeWallet', id);
}
export function getActiveWallet(storage) {
    return storage.get('activeWallet', (value) => (value === 'null' ? null : value));
}
export function addConnectedWallet(storage, id) {
    const connectedWalletList = storage.get('connectedWallet', JSON.parse);
    const connectedWalletSet = new Set(connectedWalletList);
    if (connectedWalletSet.has(id)) {
        return;
    }
    connectedWalletSet.add(id);
    storage.set('connectedWallet', [...connectedWalletSet.keys()]);
}
export function getConnectedWallet(storage) {
    return storage.get('connectedWallet', JSON.parse);
}
export function removeConnectedWallet(storage, id) {
    const connectedWalletList = storage.get('connectedWallet', JSON.parse);
    const connectedWalletSet = new Set(connectedWalletList);
    if (!connectedWalletSet.has(id)) {
        return;
    }
    connectedWalletSet.delete(id);
    storage.set('connectedWallet', [...connectedWalletSet.keys()]);
}
//# sourceMappingURL=storage.js.map